const generalNotification = () => {
	const generalNotificationActive = document.getElementById(
		'generalNotification',
	);
	const generalNotificationClose = document.getElementById(
		'generalNotificationBannerClose',
	);

	const generalNotificationClosed = () => {
		generalNotificationActive.setAttribute('aria-expanded', 'false');
		generalNotificationActive.classList.remove('general-notification--is-open');
		generalNotificationActive.classList.add('general-notification--is-closed');
	};

	if (generalNotificationClose) {
		generalNotificationClose.addEventListener('click', e => {
			generalNotificationClosed();
			document.cookie =
				'odGeneralNotification=true; sameSite=Strict; secure; path=/';
			e.preventDefault();
		});
	}
};

export default generalNotification;
